import isEmpty from "lodash/isEmpty";
import constants from "./constant";
import accessConstants from "./accessConstants";

const { CLOUD_FUN_PROD_URL, WL, CLOUD_FUN_LOCAL_URL } = constants;
const { CUSTOM_CARRER_CLAW_URL, CUSTOM_CUSTOM_RESUME_URL, LINKEDIN_URL } =
  accessConstants;

export const getCloudFunctionUrl = () => {
  const cloudFunctionUrl = CLOUD_FUN_PROD_URL;
  // const cloudFunctionUrl = CLOUD_FUN_LOCAL_URL;
  return cloudFunctionUrl;
};

// <ul><li>..</li></ul> -> "First bullet. Second bullet. " (the plain copy kept
// beside responsibilitiesHTML). Only a bullet BOUNDARY gets ". ": this used to
// put a space after every full stop, so "3.5%" became "3. 5%", "Node.js"
// became "Node. js", and the template fallback split bullets mid-number.
// Inline tags (<strong>, <br>) are dropped rather than leaked into prompts.
export const setHtmlListToPlainText = (html) => {
  return String(html || "")
    .replace(/<\/li\s*>/gi, ". ")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\.\s*\.\s/g, ". ")
    .replace(/[ \t]{2,}/g, " ");
};

// A plain-text AI reply as the string it is. The services hand back
// response.data from res.send(string); these used to be run through
// JSON.stringify and then have every `"` stripped, which left `\"`, `\t`
// and `\n` escapes in the text whenever a longer answer contained a quote,
// a tab or a line break. Strips code fences and a pair of wrapping quotes,
// which the model adds now and then despite being told not to.
export const readAiTextReply = (data) => {
  const raw = typeof data === "string" ? data : data == null ? "" : String(data);

  let text = raw
    .replace(/```[a-z]*\s*/gi, "")
    .replace(/```/g, "")
    .replace(/\r\n?/g, "\n")
    .trim();

  if (/^"[^"]*"$/.test(text) || /^\u201c[^\u201d]*\u201d$/.test(text)) {
    text = text.slice(1, -1).trim();
  }

  return text;
};

// Plain text -> <ul>. One <li> per bullet.
//
// This used to split on ". " only, which ignored line breaks completely. The
// resume parser returns one bullet PER LINE, so a role with ten bullets whose
// only ". " happened to sit inside "Mapped as-is vs. to-be" came out as TWO
// items, cut in half at the abbreviation. Sentence punctuation is not a bullet
// boundary; a newline is.
//
// Sentence splitting stays as the fallback for text with no line breaks at
// all - a summary typed into the editor as one paragraph still wants to
// become a list.
export const setPlainTextToHtmlList = (text) => {
  if (isEmpty(text) || typeof text !== "string") return "<ul></ul>";

  const lines = text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const items = lines.length > 1 ? lines : text.split(". ");

  const res = items
    // A stray "• " or "- " from the source is punctuation, not content, and
    // would otherwise sit inside the <li> next to the marker the list draws.
    .map((item) => item.trim().replace(/^[•▪◦*\-–—]\s*/, "").trim())
    .filter(Boolean)
    .map((item) => `<li>${item.endsWith(".") ? item : `${item}.`}</li>`)
    .join("");

  return `<ul>${res}</ul>`;
};

export const convertHTMLToPlainText = (html) => {
  // Create a new div element
  var tempDivElement = document.createElement("div");
  // Set the HTML content with the given value
  tempDivElement.innerHTML = html;
  // Retrieve the text property of the element
  return tempDivElement.textContent || tempDivElement.innerText || "";
};

export const getFilteredQuestions = (questionList = []) => {
  const values = [...questionList];
  let filteredValues = [];

  if (!isEmpty(questionList)) {
    values.forEach((item, index) => {
      if (index === 0) {
        filteredValues.push({ ...item, isOpen: true });
      } else {
        filteredValues.push({ ...item, isOpen: true });
      }
    });
  }

  return filteredValues;
};

export const removeAnswerFromQuestions = (questionList) => {
  const values = [...questionList];
  let filteredValues = [];

  if (!isEmpty(questionList)) {
    values.forEach((item) => {
      filteredValues.push({ ...item, answer: "" });
    });
  }

  return filteredValues;
};

export const getWriterUid = () => {
  const defaultId = "jLxbW2aUW1Vj5DtTkfZR2IImYhh1";
  const url = window.location.href;
  const urlArr = url?.split("?");
  let resumeWriterId = defaultId;

  if (urlArr && urlArr.length) {
    const paramsArr = urlArr[1];
    const paramsValueArr = paramsArr?.split("&");

    if (paramsValueArr && paramsValueArr.length) {
      const filteredArr = paramsValueArr.filter((item) =>
        item.includes("writer=")
      );

      if (filteredArr && filteredArr.length) {
        const writerArr = filteredArr[0].split("=");

        resumeWriterId = writerArr[1] || defaultId;
      }
    }
  }
  localStorage.setItem("resumeWriterId", resumeWriterId);
  return resumeWriterId;
};

export const getWhiteLabelParams = () => {
  const url = window.location.href;
  const urlArr = url?.split("?");
  let whiteLabel = "";
  let isWlKeyPresent = false;

  if (urlArr && urlArr.length) {
    const paramsArr = urlArr[1];
    const paramsValueArr = paramsArr?.split("&");

    if (paramsValueArr && paramsValueArr.length) {
      const filteredArr = paramsValueArr.filter((item) => item.includes("wl="));

      if (filteredArr && filteredArr.length) {
        const whiteLabelArr = filteredArr[0].split("=");

        isWlKeyPresent = whiteLabelArr[0] ? true : false;
        whiteLabel = whiteLabelArr[1] || "";
      }
    }
  }

  if (isWlKeyPresent && !whiteLabel) {
    localStorage.setItem("whiteLabel", whiteLabel || "");
  } else {
    const whitelabelLocalStorageValue = localStorage.getItem("whiteLabel");
    whiteLabel = whiteLabel ? whiteLabel : whitelabelLocalStorageValue;
    localStorage.setItem("whiteLabel", whiteLabel);
  }

  return whiteLabel;
};

export const getBrandText = () => {
  const whiteLabel = localStorage.getItem("whiteLabel");

  if (whiteLabel === WL.FEMALE_AND_FINANCE) {
    return "FemalesAndFinance";
  } else {
    return "CareerClaw ";
  }
};

export const getResponseMessageForSubs = () => {
  const url = window.location.href;
  const urlArr = url?.split("?");
  let response = "";

  if (urlArr && urlArr.length >= 2 && urlArr[1]) {
    const paramsValueArr = urlArr[1].split("&");
    const filteredArr = paramsValueArr.filter((item) =>
      item.includes("response=")
    );
    if (filteredArr && filteredArr.length) {
      const responseArr = filteredArr[0].split("=");
      response = responseArr[1] || "";
    }
  }
  return response;
};

export const isCustomResumeDomain = () => {
  const host = window.location.host;
  // const host = "customresume.us"; //TODO: uncomment this for testing

  // Absolute paths: with path routing a relative "./favicon.ico" on
  // /jobs/saved would resolve to /jobs/favicon.ico. The page TITLE is no
  // longer written here - it used to clobber the per-page titles that
  // CustomHead sets on every render of a component calling this - CustomHead
  // handles the CustomResume title through its defaults instead.
  // Optional chaining: a document without these <link> tags (a test, an
  // embed, a trimmed index.html) must not crash every caller of this helper.
  const isCustom = host === "customresume.us";
  document
    .getElementById("favlogo")
    ?.setAttribute("href", isCustom ? "/customfav.ico" : "/favicon.ico");
  document
    .getElementById("logo")
    ?.setAttribute("href", isCustom ? "/logo192.png" : "/logo193.png");

  return isCustom;
};

export const getLinkedInUrl = () => {
  return isCustomResumeDomain()
    ? LINKEDIN_URL.AMIT_CUSTOM_RESUME
    : LINKEDIN_URL.AMIT;
};

export const parseHtmlForTags = (
  stringToParse,
  tagStyleObj = {
    strong: { fontFamily: "Arial-Bold" },
  }
) => {
  const tagsToFind = Object.keys(tagStyleObj);

  const validURL = `[A-Za-z0-9-_.!~*'()/:?#&=[\\]]*`;

  const reOpeningTags = "<"
    .concat(tagsToFind.reduce((acc, t) => acc.concat("|").concat(t), "(b"))
    .concat(`)\\s?([a-zA-Z]+="${validURL}")*>`);
  const reMiddle = "(.*?)";
  const reClosingTags = "</"
    .concat(tagsToFind.reduce((acc, t) => acc.concat("|").concat(t), "(b"))
    .concat(")>");
  const re = reOpeningTags.concat(reMiddle).concat(reClosingTags);

  const matches = stringToParse?.match(new RegExp(re, "g")) || [];

  const elements = [];
  let tempString = stringToParse;

  // for each match, search the string for the match, and split the string into 3 parts
  //    before the match
  //    the match
  //    after the match
  //  Repeat the process for the string after the match
  matches.forEach((m) => {
    const tagToSearch = m;

    const indexOfMatch = tempString.indexOf(tagToSearch);
    const s = [
      tempString.slice(0, indexOfMatch),
      tempString.slice(indexOfMatch, indexOfMatch + tagToSearch.length),
      tempString.slice(indexOfMatch + tagToSearch.length),
    ];

    const match = tagToSearch.match(new RegExp(re, ""));

    if (!match) return;

    const tag = match[1];

    const attrs = {};
    if (match[2]) {
      const matches = match[2].match(
        new RegExp(`([a-zA-Z]+)="(${validURL})"`, "")
      );
      if (matches) {
        const [, attrKey, attrValue] = matches;
        attrs[attrKey] = attrValue;
      }
    }

    const styleToApply = tagStyleObj[tag];
    elements[elements.length] = { style: {}, child: s[0] };
    elements[elements.length] = {
      name: tag,
      attributes: attrs,
      style: styleToApply,
      child: match[3],
    };
    tempString = s[2] || "";
  });

  if (tempString && tempString.length > 0) {
    elements[elements.length] = {
      style: {},
      child: tempString,
    };
  }
  return elements;
};

// A JSON AI reply as a valid single-line JSON string, for the resume import /
// draft pages that JSON.parse what this returns. Those endpoints answer with
// res.json(object), so axios already hands back an object; the pages used to
// JSON.stringify it and then strip `" "` (and on the ATS page the first `"`),
// which broke the JSON outright - a field whose value was one space became
// `"x":` and the whole import failed with nothing on screen. Whitespace-only
// strings become "" here instead, which is what that strip was reaching for.
// Returns "" when the reply is not JSON at all.
const blankWhitespaceStrings = (value) => {
  if (typeof value === "string") return value.trim() ? value : "";
  if (Array.isArray(value)) return value.map(blankWhitespaceStrings);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, blankWhitespaceStrings(item)])
    );
  }
  return value;
};

export const toAiJsonText = (data) => {
  let value = data;

  if (typeof value === "string") {
    const cleaned = readAiTextReply(value);
    try {
      value = JSON.parse(cleaned);
    } catch (error) {
      const start = cleaned.search(/[[{]/);
      const end = Math.max(cleaned.lastIndexOf("}"), cleaned.lastIndexOf("]"));
      if (start === -1 || end <= start) return "";
      try {
        value = JSON.parse(cleaned.slice(start, end + 1));
      } catch (innerError) {
        return "";
      }
    }
  }

  if (!value || typeof value !== "object") return "";
  return JSON.stringify(blankWhitespaceStrings(value));
};
